// src/shell/Header.jsx
import { T } from '@components/theme';
import { StatusChip } from '@components/ui';

export function Header({ zone, online, onZonePress, sourceStale = false, staleSourceName = null, backendState = null, sourceState = null }) {
  return (
    <>
    <a href="#main-content" style={{
      position:'absolute', top:-40, left:0, padding:'8px 16px',
      background:'#0369a1', color:'#fff', fontWeight:700, fontSize:12,
      zIndex:9999, borderRadius:'0 0 8px 0',
      transition:'top 0.2s',
    }}
    onFocus={e => e.target.style.top='0'}
    onBlur={e => e.target.style.top='-40px'}
    >Skip to main content</a>
    <div style={{
      display: 'flex', alignItems: 'center',
      padding: '10px 14px', gap: 10,
      background: T.card, borderBottom: `1px solid ${T.bdr}`,
      flexShrink: 0,
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: 10,
        background: T.amber, display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        fontSize: 20, flexShrink: 0,
      }}>
        🏠
      </div>

      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 900, fontSize: 15, color: T.text, lineHeight: 1 }}>
          Eye on Storm
        </div>
        <div style={{ fontSize: 9, fontWeight: 800, color: T.amber, letterSpacing: 1.5, textTransform: 'uppercase', marginTop: 2 }}>
          Louisiana Community Network
        </div>
      </div>

      <StatusChip online={online} sourceStale={sourceStale} staleSourceName={staleSourceName} backendState={backendState} sourceState={sourceState} />

      <button
        onClick={onZonePress}
        style={{
          background: T.bg2, border: `1px solid ${T.bdr}`,
          borderRadius: 8, padding: '5px 10px',
          fontSize: 11, fontWeight: 700, cursor: 'pointer',
          fontFamily: T.font, textAlign: 'right', minWidth: 70,
        }}
      >
        <div style={{ fontSize: 10, color: T.dim }}>📍 Zone</div>
        <div style={{ color: T.text, fontWeight: 800 }}>{zone ?? 'Select'}</div>
      </button>
    </div>
    </>
  );
}
